var _path, _path2, _path3, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentContract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M0 0v24.945h24V0H0zm22.67 4.059V23.616H1.33V1.329h21.34v2.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    fillRule: "evenodd",
    d: "M7.004 13.8c.05-1.262.565-2.44 1.461-3.336.487-.486 1.054-.859 1.675-1.107.074-.03.15-.058.225-.084-.066-.045-.13-.093-.191-.143-.65-.531-1.066-1.336-1.066-2.239 0-1.595 1.296-2.89 2.892-2.89 1.596 0 2.892 1.298 2.892 2.89 0 .903-.417 1.708-1.066 2.239-.062.05-.125.098-.19.143.075.026.15.055.224.084.618.249 1.188.62 1.675 1.107.896.896 1.409 2.074 1.46 3.337.003.066.005.133.005.2h-.78c0-2.326-1.893-4.219-4.22-4.219s-4.22 1.893-4.22 4.219H7c0-.067.001-.134.004-.2zm7.032-4.586c.645-.566 1.056-1.396 1.056-2.323 0-1.702-1.386-3.09-3.092-3.09-1.706 0-3.092 1.385-3.092 3.09 0 .927.41 1.756 1.055 2.323-.605.257-1.16.63-1.639 1.109C7.344 11.303 6.8 12.61 6.8 14v.2h1.18V14c0-2.216 1.803-4.019 4.02-4.019 2.217 0 4.02 1.803 4.02 4.019v.2h1.18V14c-.003-1.39-.543-2.698-1.524-3.678-.48-.48-1.036-.852-1.64-1.11zM10.088 6.89c0 1.051.857 1.908 1.909 1.908 1.051 0 1.908-.857 1.908-1.908 0-1.05-.857-1.907-1.908-1.907-1.052 0-1.909.856-1.909 1.907zm-.2 0c0 1.162.947 2.108 2.109 2.108s2.108-.946 2.108-2.108c0-1.161-.946-2.107-2.108-2.107-1.162 0-2.109.946-2.109 2.107z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    fillRule: "evenodd",
    d: "M8.465 10.464c-.896.896-1.412 2.074-1.461 3.337C7 13.867 7 13.934 7 14h.78c0-2.326 1.893-4.219 4.22-4.219s4.22 1.893 4.22 4.219H17c0-.067-.002-.134-.004-.2-.052-1.263-.565-2.441-1.461-3.337-.487-.486-1.057-.858-1.675-1.107-.074-.03-.15-.058-.225-.084.066-.045.13-.093.191-.143.65-.53 1.066-1.336 1.066-2.239 0-1.592-1.296-2.89-2.892-2.89-1.596 0-2.892 1.295-2.892 2.89 0 .903.417 1.708 1.066 2.239.061.05.125.098.19.143-.075.026-.15.054-.224.084-.62.248-1.188.62-1.675 1.107zm1.423-3.573c0 1.162.947 2.108 2.109 2.108s2.108-.946 2.108-2.108c0-1.161-.946-2.107-2.108-2.107-1.162 0-2.109.946-2.109 2.107z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1,
    x: 6,
    y: 17,
    fill: "#8C8C8C",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1,
    x: 6,
    y: 20,
    fill: "#8C8C8C",
    rx: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentContract);
export default __webpack_public_path__ + "static/media/agentContract.513adb7823119f852c5cce87d3b0284f.svg";
export { ForwardRef as ReactComponent };